<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import type { CurrentRoute } from "svelte-router-spa/types/components/route";

  import SubNavUnit from "@/components/subnav-unit.svelte";
  import Spacer from "@/components/spacer.svelte";
  import router from "@/router";

  const menulist = router.find((x) => x.id == "bandiburri")?.nestedRoutes || [];
  export let currentRoute: CurrentRoute;
</script>

<Spacer size="150px" />

<div id="wrap">
  <h1>INTRODUCE</h1>

  <Spacer size="2rem" />

  <div class="position-relative">
    <div class="position-absolute w600-mobile start-50 translate-middle-x">
      <Row style="--bs-gutter-x: 0 !important;">
        {#each menulist as menu, i}
          <Col style="padding: 0 !important;">
            <SubNavUnit
              href="/bandiburri/{menu.name}"
              active={currentRoute.path.split("/").pop() == menu.name}
            >
              {menu.label}
            </SubNavUnit>
          </Col>
        {/each}
      </Row>
    </div>
  </div>

  <Spacer size="5rem" class_ext="pc" />
  <Spacer size="8rem" class_ext="mobile" />
</div>

<style lang="scss">
  .w600-mobile {
    width: 330px;
  }
  @media (min-width: 768px) {
    .w600-mobile {
      width: 600px !important;
    }
  }

  #wrap {
    color: #5c3327;

    h1 {
      font-size: 3rem;
      font-weight: 700;
      text-align: center;
    }
  }
</style>
